import { CannabinoidAbbrev } from 'shared/constants/cannabinoids';
import CBCIcon from './CBC';
import CBCAIcon from './CBCA';
import CBCVIcon from './CBCV';
import CBDAIcon from './CBDA';
import CBDVIcon from './CBDV';
import CBDVAIcon from './CBDVA';
import CBGIcon from './CBG';
import CBGAIcon from './CBGA';
import CBGVIcon from './CBGV';
import CBLIcon from './CBL';
import CBLAIcon from './CBLA';
import CBNIcon from './CBN';
import CBNAIcon from './CBNA';
import CBTIcon from './CBT';
import D8THCIcon from './D8-THC';
import D9THCIcon from './D9-THC';
import THCAIcon from './THCA';
import THCVIcon from './THCV';
import THCVAIcon from './THCVA';

export default {
  [CannabinoidAbbrev.CBC]: CBCIcon,
  [CannabinoidAbbrev.CBCA]: CBCAIcon,
  [CannabinoidAbbrev.CBCV]: CBCVIcon,
  [CannabinoidAbbrev.CBCVA]: CBCVIcon,
  [CannabinoidAbbrev.CBDA]: CBDAIcon,
  [CannabinoidAbbrev.CBDV]: CBDVIcon,
  [CannabinoidAbbrev.CBDVA]: CBDVAIcon,
  [CannabinoidAbbrev.CBG]: CBGIcon,
  [CannabinoidAbbrev.CBGA]: CBGAIcon,
  [CannabinoidAbbrev.CBGV]: CBGVIcon,
  [CannabinoidAbbrev.CBGVA]: CBGVIcon,
  [CannabinoidAbbrev.CBL]: CBLIcon,
  [CannabinoidAbbrev.CBLA]: CBLAIcon,
  [CannabinoidAbbrev.CBN]: CBNIcon,
  [CannabinoidAbbrev.CBNA]: CBNAIcon,
  [CannabinoidAbbrev.CBT]: CBTIcon,
  [CannabinoidAbbrev['D8-THC']]: D8THCIcon,
  [CannabinoidAbbrev['D9-THC']]: D9THCIcon,
  [CannabinoidAbbrev.THCA]: THCAIcon,
  [CannabinoidAbbrev.THCV]: THCVIcon,
  [CannabinoidAbbrev.THCVA]: THCVAIcon,
};
